export function Marquee({ items, speed = "animate-marquee", separator = "✦" }) {
  const row = [...items, ...items];
  return (
    <div className="relative w-full overflow-hidden py-4 select-none">
      <div className={`flex whitespace-nowrap ${speed}`}>
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-6 font-display text-2xl sm:text-4xl font-extrabold uppercase tracking-tight text-transparent [-webkit-text-stroke:1px_rgba(148,163,184,0.35)]">
              {item}
            </span>
            <span className="text-neon-magenta text-xl">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
